import {connect} from 'react-redux';
import * as ModalActions from '../../actions/ModalActions';
import {withRouter} from 'react-router';
import {State} from '../../types/mx/reducers';
import OpenImageView from '../../components/views/mx/OpenImageView';

const mapStateToProps = (state: State, ownProps) => {
    const data = ownProps.data;
    return {
        imageUrl: data.imageUrl
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCancel: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

const OpenImageContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(OpenImageView));

export default OpenImageContainer;